import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange);
  return () => document.removeEventListener('visibilitychange', onChange);
};

const getSnapshot = () => document.visibilityState === 'visible';

// False while the page is hidden: a background tab, or a window that is minimized or covered
export const useTabVisible = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
